import type { AiSource } from "../../api/aiApi";

/** Fired so the page that owns the document can scroll to a cited passage. */
export const AI_OPEN_SOURCE_EVENT = "lawsigna:ai-open-source";

export interface AiOpenSourceDetail {
  contractId: string;
  source: AiSource;
}

export function openAiSource(detail: AiOpenSourceDetail) {
  window.dispatchEvent(new CustomEvent<AiOpenSourceDetail>(AI_OPEN_SOURCE_EVENT, { detail }));
}
